// ARCHIVO GENERADO — no editar a mano.
// Fuente: renderer/tabs/widgets/index.js (objeto `const widgets`).
// Se regenera con `npm run catalog:sync` y en cada dev/build del backoffice
// (scripts/sync-widgets-catalog.mjs). Generado: 2026-11-03T16:51:59.422Z.

export const CATALOG = [
  {
    "key": "top-rotation",
    "title": "Top Rotation",
    "category": "rankings",
    "tier": "premium",
    "v2": true
  },
  {
    "key": "top-likes",
    "title": "Top Likes",
    "category": "rankings",
    "tier": "free",
    "v2": true
  },
  {
    "key": "top-donors",
    "title": "Top Donors",
    "category": "rankings",
    "tier": "free",
    "v2": true
  },
  {
    "key": "top-comments",
    "title": "Top Comments",
    "category": "rankings",
    "tier": "premium",
    "v2": true
  },
  {
    "key": "top-gift",
    "title": "Top Gift",
    "category": "rankings",
    "tier": "free",
    "v2": true
  },
  {
    "key": "top-combo",
    "title": "Top Combo",
    "category": "rankings",
    "tier": "free",
    "v2": true
  },
  {
    "key": "top-points",
    "title": "Top Points",
    "category": "rankings",
    "tier": "free",
    "v2": true
  },
  {
    "key": "carousel-fans",
    "title": "Carrusel de fans",
    "category": "rankings",
    "tier": "premium"
  },
  {
    "key": "carousel-gifts",
    "title": "Carrusel de regalos",
    "category": "rankings",
    "tier": "premium"
  },
  {
    "key": "carousel-mix",
    "title": "Carrusel mixto",
    "category": "rankings",
    "tier": "premium"
  },
  {
    "key": "chat",
    "title": "Chat",
    "category": "free",
    "tier": "premium"
  },
  {
    "key": "timer",
    "title": "Timer",
    "category": "free",
    "tier": "premium"
  },
  {
    "key": "like-fountain",
    "title": "Like Fountain",
    "category": "free",
    "tier": "free"
  },
  {
    "key": "gift-cannon",
    "title": "Gift Cannon",
    "category": "free",
    "tier": "free"
  },
  {
    "key": "gift-jar",
    "title": "Gift Jar",
    "category": "free",
    "tier": "free"
  },
  {
    "key": "firework",
    "title": "Fireworks",
    "category": "free",
    "tier": "free"
  },
  {
    "key": "social-media-rotator",
    "title": "Social Media",
    "category": "free",
    "tier": "free",
    "disabled": true
  },
  {
    "key": "pinned-message",
    "title": "Pinned Message",
    "category": "free",
    "tier": "premium"
  },
  {
    "key": "follower-counter",
    "title": "Contador de seguidores",
    "category": "free",
    "tier": "free"
  },
  {
    "key": "event-notification",
    "title": "Notificación Premium",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "community-fest",
    "title": "Community FEST 26",
    "category": "premium",
    "tier": "premium",
    "devOnly": true
  },
  {
    "key": "subtitles",
    "title": "Subtítulos en vivo",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "effects",
    "title": "Efectos Visuales",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "gift-alert",
    "title": "Gift Alert",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "level_up",
    "title": "Level Up",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "mvp",
    "title": "MVP de la Batalla",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "gift-battle",
    "title": "Gift Battle",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "battle-pk",
    "title": "Battle PK",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "auction",
    "title": "Auction",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "winlife",
    "title": "Win/Life",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "reset-save",
    "title": "Reset y Salvar",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "follower-welcome",
    "title": "Bienvenida a seguidores",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "momento-x2",
    "title": "Momento ×2",
    "category": "premium",
    "tier": "premium",
    "devOnly": true
  },
  {
    "key": "ranks",
    "title": "Ranks",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "roulette",
    "title": "Roulette",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "firework-premium",
    "title": "FireWork Premium",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "gift-jar-premium",
    "title": "Gift Jar Premium",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "gift-gallery",
    "title": "Gift Gallery",
    "category": "premium",
    "tier": "premium"
  },
  {
    "key": "anim-x2-tikcontrol",
    "title": "X2 - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "x2"
  },
  {
    "key": "anim-x2-gladiador",
    "title": "X2 - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "x2"
  },
  {
    "key": "anim-x2-magia",
    "title": "X2 - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "x2"
  },
  {
    "key": "anim-x2-basico",
    "title": "X2 - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "x2"
  },
  {
    "key": "anim-x2-mundial",
    "title": "X2 - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "x2"
  },
  {
    "key": "anim-x3-tikcontrol",
    "title": "X3 - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "x3"
  },
  {
    "key": "anim-x3-gladiador",
    "title": "X3 - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "x3"
  },
  {
    "key": "anim-x3-magia",
    "title": "X3 - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "x3"
  },
  {
    "key": "anim-x3-basico",
    "title": "X3 - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "x3"
  },
  {
    "key": "anim-x3-mundial",
    "title": "X3 - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "x3"
  },
  {
    "key": "anim-guantes-tikcontrol",
    "title": "Guantes - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "guantes"
  },
  {
    "key": "anim-guantes-gladiador",
    "title": "Guantes - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "guantes"
  },
  {
    "key": "anim-guantes-magia",
    "title": "Guantes - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "guantes"
  },
  {
    "key": "anim-guantes-basico",
    "title": "Guantes - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "guantes"
  },
  {
    "key": "anim-guantes-mundial",
    "title": "Guantes - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "guantes"
  },
  {
    "key": "anim-cofre-tikcontrol",
    "title": "Cofre - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "cofre"
  },
  {
    "key": "anim-cofre-gladiador",
    "title": "Cofre - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "cofre"
  },
  {
    "key": "anim-cofre-magia",
    "title": "Cofre - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "cofre"
  },
  {
    "key": "anim-cofre-basico",
    "title": "Cofre - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "cofre"
  },
  {
    "key": "anim-cofre-mundial",
    "title": "Cofre - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "cofre"
  },
  {
    "key": "anim-snipe-tikcontrol",
    "title": "Snipe - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "snipe"
  },
  {
    "key": "anim-snipe-gladiador",
    "title": "Snipe - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "snipe"
  },
  {
    "key": "anim-snipe-magia",
    "title": "Snipe - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "snipe"
  },
  {
    "key": "anim-snipe-basico",
    "title": "Snipe - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "snipe"
  },
  {
    "key": "anim-snipe-mundial",
    "title": "Snipe - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "snipe"
  },
  {
    "key": "anim-taptap-tikcontrol",
    "title": "Tap Tap - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "taptap"
  },
  {
    "key": "anim-taptap-gladiador",
    "title": "Tap Tap - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "taptap"
  },
  {
    "key": "anim-taptap-magia",
    "title": "Tap Tap - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "taptap"
  },
  {
    "key": "anim-taptap-basico",
    "title": "Tap Tap - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "taptap"
  },
  {
    "key": "anim-taptap-mundial",
    "title": "Tap Tap - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "taptap"
  },
  {
    "key": "anim-quiereme-tikcontrol",
    "title": "Quiéreme - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "quiereme"
  },
  {
    "key": "anim-quiereme-gladiador",
    "title": "Quiéreme - Pack Gladiador",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "gladiador",
    "animType": "quiereme"
  },
  {
    "key": "anim-quiereme-magia",
    "title": "Quiéreme - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "quiereme"
  },
  {
    "key": "anim-quiereme-basico",
    "title": "Quiéreme - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "quiereme"
  },
  {
    "key": "anim-quiereme-mundial",
    "title": "Quiéreme - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "hasTeamSelector": true,
    "pack": "mundial",
    "animType": "quiereme"
  },
  {
    "key": "anim-quiereme-mundial-portero",
    "title": "Quiéreme Portero - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "quiereme",
    "animVariant": "mundial-portero"
  },
  {
    "key": "anim-enigma-tikcontrol",
    "title": "Enigma - Pack TikControl",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "tikcontrol",
    "animType": "enigma"
  },
  {
    "key": "anim-enigma-magia",
    "title": "Enigma - Pack Bosque Encantado",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "magia",
    "animType": "enigma"
  },
  {
    "key": "anim-enigma-basico",
    "title": "Enigma - Pack Chroma",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "basico",
    "animType": "enigma"
  },
  {
    "key": "anim-enigma-mundial",
    "title": "Enigma - Pack World Cup 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "mundial",
    "animType": "enigma"
  },
  {
    "key": "anim-fan-tikcontrol",
    "title": "Fan - Subida de nivel",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "levelUpAnimation": true,
    "pack": "tikcontrol",
    "animType": "fan"
  },
  {
    "key": "anim-donador-tikcontrol",
    "title": "Donador - Subida de nivel",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "levelUpAnimation": true,
    "pack": "tikcontrol",
    "animType": "donador"
  },
  {
    "key": "anim-x2-community-fest",
    "title": "X2 - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "x2"
  },
  {
    "key": "anim-x3-community-fest",
    "title": "X3 - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "x3"
  },
  {
    "key": "anim-guantes-community-fest",
    "title": "Guantes - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "guantes"
  },
  {
    "key": "anim-cofre-community-fest",
    "title": "Cofre - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "cofre"
  },
  {
    "key": "anim-snipe-community-fest",
    "title": "Snipe - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "snipe"
  },
  {
    "key": "anim-taptap-community-fest",
    "title": "Tap Tap - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "taptap"
  },
  {
    "key": "anim-quiereme-community-fest",
    "title": "Quiéreme - Community Fest 2026",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "community-fest",
    "animType": "quiereme"
  },
  {
    "key": "anim-x2-atlantis",
    "title": "X2 - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "x2"
  },
  {
    "key": "anim-x3-atlantis",
    "title": "X3 - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "x3"
  },
  {
    "key": "anim-guantes-atlantis",
    "title": "Guantes - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "guantes"
  },
  {
    "key": "anim-cofre-atlantis",
    "title": "Cofre - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "cofre"
  },
  {
    "key": "anim-snipe-atlantis",
    "title": "Snipe - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "snipe"
  },
  {
    "key": "anim-taptap-atlantis",
    "title": "Tap Tap - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "taptap"
  },
  {
    "key": "anim-quiereme-atlantis",
    "title": "Quiéreme - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "quiereme"
  },
  {
    "key": "anim-enigma-atlantis",
    "title": "Enigma - Atlantis",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "atlantis",
    "animType": "enigma"
  },
  {
    "key": "anim-x2-candy",
    "title": "X2 - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "x2"
  },
  {
    "key": "anim-x3-candy",
    "title": "X3 - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "x3"
  },
  {
    "key": "anim-guantes-candy",
    "title": "Guantes - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "guantes"
  },
  {
    "key": "anim-cofre-candy",
    "title": "Cofre - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "cofre"
  },
  {
    "key": "anim-snipe-candy",
    "title": "Snipe - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "snipe"
  },
  {
    "key": "anim-taptap-candy",
    "title": "Tap Tap - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "taptap"
  },
  {
    "key": "anim-quiereme-candy",
    "title": "Quiéreme - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "quiereme"
  },
  {
    "key": "anim-enigma-candy",
    "title": "Enigma - Candy",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "candy",
    "animType": "enigma"
  },
  {
    "key": "anim-x2-halloween",
    "title": "X2 - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "x2"
  },
  {
    "key": "anim-x3-halloween",
    "title": "X3 - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "x3"
  },
  {
    "key": "anim-guantes-halloween",
    "title": "Guantes Garra - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "guantes"
  },
  {
    "key": "anim-guantes-halloween-mano",
    "title": "Guantes Mano - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "guantes",
    "animVariant": "halloween-mano"
  },
  {
    "key": "anim-cofre-halloween",
    "title": "Cofre - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "cofre"
  },
  {
    "key": "anim-snipe-halloween",
    "title": "Snipe - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "snipe"
  },
  {
    "key": "anim-taptap-halloween",
    "title": "Tap Tap - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "taptap"
  },
  {
    "key": "anim-quiereme-halloween",
    "title": "Quiéreme Vampiro - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "quiereme"
  },
  {
    "key": "anim-quiereme-halloween-payaso",
    "title": "Quiéreme Payaso - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "quiereme",
    "animVariant": "halloween-payaso"
  },
  {
    "key": "anim-quiereme-halloween-marioneta",
    "title": "Quiéreme Marioneta - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "quiereme",
    "animVariant": "halloween-marioneta"
  },
  {
    "key": "anim-enigma-halloween",
    "title": "Enigma - Pack Halloween",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "halloween",
    "animType": "enigma"
  },
  {
    "key": "anim-x2-muertos",
    "title": "X2 - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "x2"
  },
  {
    "key": "anim-x3-muertos",
    "title": "X3 - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "x3"
  },
  {
    "key": "anim-guantes-muertos",
    "title": "Guantes - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "guantes"
  },
  {
    "key": "anim-cofre-muertos",
    "title": "Cofre - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "cofre"
  },
  {
    "key": "anim-snipe-muertos",
    "title": "Snipe - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "snipe"
  },
  {
    "key": "anim-taptap-muertos",
    "title": "Tap Tap - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "taptap"
  },
  {
    "key": "anim-quiereme-muertos",
    "title": "Quiéreme - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "quiereme"
  },
  {
    "key": "anim-enigma-muertos",
    "title": "Enigma Catrina - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "enigma"
  },
  {
    "key": "anim-enigma-muertos-mago",
    "title": "Enigma Mago - Pack Día de los Muertos",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "pack": "muertos",
    "animType": "enigma",
    "animVariant": "muertos-mago"
  },
  {
    "key": "anim-cortinilla-atlantis",
    "title": "Intro de batalla - Pack Atlantis",
    "category": "premium",
    "tier": "premium",
    "animation": true,
    "pack": "atlantis",
    "animType": "cortinilla"
  },
  {
    "key": "anim-cortinilla-candy",
    "title": "Intro de batalla - Pack Candy",
    "category": "premium",
    "tier": "premium",
    "animation": true,
    "pack": "candy",
    "animType": "cortinilla"
  },
  {
    "key": "anim-quiereme-random",
    "title": "Quiéreme - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "quiereme",
    "animVariant": "random"
  },
  {
    "key": "anim-taptap-random",
    "title": "Tap Tap - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "taptap",
    "animVariant": "random"
  },
  {
    "key": "anim-x2-random",
    "title": "X2 - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "x2",
    "animVariant": "random"
  },
  {
    "key": "anim-x3-random",
    "title": "X3 - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "x3",
    "animVariant": "random"
  },
  {
    "key": "anim-guantes-random",
    "title": "Guantes - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "guantes",
    "animVariant": "random"
  },
  {
    "key": "anim-snipe-random",
    "title": "Snipe - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "snipe",
    "animVariant": "random"
  },
  {
    "key": "anim-cofre-random",
    "title": "Cofre - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "cofre",
    "animVariant": "random"
  },
  {
    "key": "anim-enigma-random",
    "title": "Enigma - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "enigma",
    "animVariant": "random"
  },
  {
    "key": "anim-cortinilla-random",
    "title": "Intro de batalla - Pack Random",
    "category": "premium",
    "tier": "premium",
    "v2": true,
    "animation": true,
    "random": true,
    "pack": "random",
    "animType": "cortinilla",
    "animVariant": "random"
  }
];

export const CATEGORIES = ["rankings","free","premium"];
export const PACKS = ["tikcontrol","gladiador","magia","basico","mundial","community-fest","atlantis","candy","halloween","muertos","random"];
export const ANIM_TYPES = ["x2","x3","guantes","cofre","snipe","taptap","quiereme","enigma","fan","donador","cortinilla"];

// Etiquetas que la app trae escritas (clave → día en que caducan).
export const APP_NEW_BADGES = {"carousel-fans":"2026-12-15","carousel-gifts":"2026-12-15","carousel-mix":"2026-12-15","follower-counter":"2026-12-31","subtitles":"2026-12-31","reset-save":"2026-12-31","follower-welcome":"2026-12-31","anim-pack-atlantis":"2026-08-31","anim-pack-candy":"2026-08-31","anim-pack-halloween":"2026-11-30","anim-pack-muertos":"2026-11-30","goals-countdown":"2026-08-31","goals-gift":"2026-11-30","effects":"2026-08-31","anim-type-cortinilla":"2026-08-31"};
export const APP_IMPROVED_BADGES = {"level_up":"2026-11-30","ranks":"2026-11-30","roulette":"2026-11-30"};
